import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsBoatFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_boat_filled"}/>
}
